export default "images/wego-logo.svg";